var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisclaimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5518 13.1535V16.5991M16.5518 20.0448H16.5604M15.0787 8.72585L7.78263 20.9062C7.63188 21.1667 7.55263 21.462 7.55176 21.7628C7.5509 22.0636 7.62842 22.3594 7.77745 22.6208C7.92647 22.8821 8.14183 23.0999 8.40025 23.2525C8.65954 23.405 8.955 23.487 9.25563 23.4904H23.8479C24.1485 23.487 24.4431 23.405 24.7024 23.2525C24.9617 23.0999 25.1762 22.8821 25.3252 22.6208C25.4742 22.3594 25.5526 22.0636 25.5517 21.7628C25.5509 21.462 25.4708 21.1667 25.3209 20.9062L18.0248 8.72585C17.8714 8.47268 17.6544 8.26336 17.3968 8.11804C17.1384 7.97281 16.8481 7.89648 16.5518 7.89648C16.2554 7.89648 15.9643 7.97281 15.7067 8.11804C15.4483 8.26336 15.2321 8.47268 15.0787 8.72585Z",
    stroke: "#505780",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisclaimer);
export default __webpack_public_path__ + "static/media/Disclaimer.42f19f8ab00abdbc8e36efd5b8ac463f.svg";
export { ForwardRef as ReactComponent };